export { default } from './HR'
